import React from "react";
import { About } from "../ui/CommonStyles";

import commissions1 from "../img/commission/commissions1.png";
import commissions2 from "../img/commission/commissions2.png";
import commissions3 from "../img/commission/commissions3.png";
import commissions4 from "../img/commission/commissions4.png";
import commissions5 from "../img/commission/commissions5.png";
import commissions6 from "../img/commission/commissions6.png";

import ModalImage from "react-modal-image";

function CommissionPage() {
  return (
    <About className="container">
      <div className="row">
        {/* First image column */}
        <div className="col-md-4 col-sm-4 col-xs-12 d-flex flex-column">
          {[commissions1, commissions3, commissions5].map((img, i) => (
            <div key={i} className="thumbnail mb-3">
              <ModalImage
                className="image-commission"
                small={img}
                large={img}
                hideDownload={true}
                hideZoom={true}
                alt={`commission-${i + 1}`}
              />
            </div>
          ))}
        </div>

        {/* Second image column */}
        <div className="col-md-4 col-sm-4 col-xs-12 d-flex flex-column">
          {[commissions2, commissions4, commissions6].map((img, i) => (
            <div key={i} className="thumbnail mb-3">
              <ModalImage
                className="image-commission"
                small={img}
                large={img}
                hideDownload={true}
                hideZoom={true}
                alt={`commission-${i + 4}`}
              />
            </div>
          ))}
        </div>

        {/* Commissions text section */}
        <div className="col-md-4 col-sm-12 col-xs-12">
          <h1>commissions</h1>
          <p className="bio-text">
            For commission requests please fill out this form:
          </p>
          <p className="bio-text">
            <a
              href="https://docs.google.com/forms/d/e/1FAIpQLSfrmBKbKTdvUMVo0IRm1uFb1HwjQKgi-e9ZZUJE8THx9Z9usA/viewform"
              target="_blank"
              rel="noopener noreferrer"
            >
              Commission Form
            </a>
          </p>
          <p className="bio-text">
            For questions or business inquiries please email me at:
          </p>
          <p className="bio-text">lupineravenartworks@gmail.com</p>
        </div>
      </div>
    </About>
  );
}

export default CommissionPage;
